import React , {Component}from 'react';
import { Link } from 'react-router-dom';
import { connect } from 'react-redux';
import * as routes from '../../constants/routes';
import SignOutButton from '../SignOut';
import firebase from 'firebase';
import '../css/main.css';

const Navigation = ({ authUser , admin , history}) =>
  <div>
    { authUser 
        ? <NavigationAuth admin={admin} history = {history}/>
        : <NavigationNonAuth />
    }
  </div>

class NavigationAuth extends Component{

  constructor(props){
    super();
    this.state = {
      admin : false
    }
  }
  
  componentWillMount() {
    var uid = firebase.auth().currentUser.uid , self = this;
    const {history} = this.props;
    firebase.database().ref('users/admin/details').once('value',function(snap){
      if(snap.hasChild(uid)){
        self.setState({
          admin : true
        })
      }
    })
  }

  render(){
    return(
      <div className="background_view">

        <div>
          <header className="header-user-dropdown">
            <div className="header-limiter">
              <div>
                <img src={require('../../images/logo.png')} className="logo"/>
                <h1>Sri Universal Suraksha Card</h1>
              </div>
            </div>
          </header>
          <nav className="main-menu">
            <ul>
              { this.state.admin ? 
                <div>
                  <li>
                    <Link to={routes.ADMIN}>
                            <i className="fa fa-home fa-2x"></i>
                            <span className="nav-text">
                                Dashboard
                            </span>
                    </Link>
                  </li>
                  <li>
                    <Link to={routes.VENDORHISTORY}>
                          <i className="fa fa-clock-o fa-2x"></i>
                          <span className="nav-text">
                              History
                          </span>
                    </Link>
                  </li>
                  <li>
                    <Link to={routes.UPLOADUSER}>
                          <i className="fa fa-upload fa-2x"></i>
                          <span className="nav-text">
                              Upload User
                          </span>
                    </Link>
                  </li>
                  <li>
                    <Link to={routes.CHATADMIN}>
                      <i className="fa fa-comments-o  fa-2x"></i>
                      <span className="nav-text">
                          Chat Service
                      </span>
                    </Link>
                  </li>
                </div>
                : 
                <div>
                  <li>
                    <Link to={routes.HOME}>
                      <i className="fa fa-home fa-2x"></i>
                      <span className="nav-text">
                          Dashboard
                      </span>
                    </Link>
                  </li>
                  <li>
                    <Link to={routes.FORMUPLOAD}>
                      <i className="fa fa-upload fa-2x"></i>
                      <span className="nav-text">
                          Form Uploads
                      </span>
                    </Link>
                  </li>
                  <li>
                    <Link to={routes.CHATUSER}>
                      <i className="fa fa-comments-o  fa-2x"></i>
                      <span className="nav-text">
                          Chat Service
                      </span>
                    </Link>
                  </li>
                </div>
              }
              <li>
                <Link to={routes.ACCOUNT}>
                  <i className="fa fa-user fa-2x"></i>
                  <span className="nav-text">
                      Account
                  </span>
                </Link>
              </li>
              <li  className="logout">
                <a>
                  <i className="fa fa-power-off  fa-2x"></i>
                  <span className="nav-text">
                    <SignOutButton />
                  </span>
                </a>
              </li>
            </ul>
          </nav>
        </div>
      </div>
    )
  }
}


const NavigationNonAuth = () =><Link to={routes.SIGN_IN}></Link>

const mapStateToProps = (state) => ({
  authUser: state.sessionState.authUser,
});

export default connect(mapStateToProps)(Navigation);
